const black = '#000000';
const white = '#FFFFFF';
export const theme = {
  additions: {
    content: {
      color1: black,
      color2: '#566f82',
    },
    item: {
      highlight1: '#eef1f4',
    },
  },

  element: {
    bg1: white,
  },
};
